import 'babel-polyfill'
import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue/dist/bootstrap-vue.esm'
import VueToast from 'vue-toast-notification'
import 'vue-toast-notification/dist/theme-default.css'
import VueGtag from 'vue-gtag'
import router from './router'
import './plugins/axios'
import store from './store/store'
import './serviceWorkerKill.js'
import VueMeta from 'vue-meta'
import JsonExcel from 'vue-json-excel'
import FonteEsusPecGlobal from '@/components/FonteEsusPecGlobal.vue'
import FonteSincronizadorC from '@/components/FonteSincronizadorC.vue'
import { api, apiPublic } from '@/plugins/axios.js'
import vuetify from './plugins/vuetify'
import VueIziToast from 'vue-izitoast'
import 'izitoast/dist/css/iziToast.css'
import VueCookies from 'vue-cookies'
import VueSelect from 'vue-select'
import 'vue-select/dist/vue-select.css'
import VueTypedJs from 'vue-typed-js'
import MaisIndicadoresTabs from '@/components/MaisIndicadores/Index.vue'

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/css/style.css'
import './assets/css/icofont.min.css'
import './assets/css/animation.css'

import Inputmask from 'inputmask'

Vue.component('downloadExcel', JsonExcel)
Vue.component('FonteEsusPecGlobal', FonteEsusPecGlobal)
Vue.component('FonteSincronizadorC', FonteSincronizadorC)
Vue.component('MaisIndicadoresTabs', MaisIndicadoresTabs)
Vue.prototype.$api = api
Vue.prototype.$apiPublic = apiPublic
Vue.use(VueMeta)
Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(VueIziToast, { position: 'topRight' })
Vue.use(VueToast)
// Google analytics
Vue.use(VueGtag, {
  config: { id: 'G-M3NVL3RKBD' },
  enabled: false,
})
Vue.use(VueCookies, { expires: '7d' })
Vue.component('vue-select', VueSelect)
Vue.use(VueTypedJs)

Vue.directive('inputmask', {
  bind(el, binding) {
    new Inputmask(binding.value).mask(el)
  },
})

export const vue = new Vue({
  store,
  router,
  vuetify,
  render: (h) => h(App),
}).$mount('#app')
